import React from "react";
import "./Sidebar.css";
import { NavLink } from "react-router-dom";
import { LiaBlogger } from "react-icons/lia";
import { RiLogoutBoxRLine } from "react-icons/ri";
import { MdOutlineContactMail, MdOutlineCreateNewFolder, MdOutlineContactPhone, MdOutlineDashboard, MdWorkOutline, MdContactPage, MdOutlineCases } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { LogOutUser } from "../../actions/userActions";
import Logo from "../../asserts/logo.png";
import {
  CONTACT_ACCESS_ROLES,
  CONTENT_ACCESS_ROLES,
  FULL_ACCESS_ROLES,
  JOB_ACCESS_ROLES,
} from "../../utils/roleAccess";

const sidebarItems = [
  {
    to: "/",
    icon: MdOutlineDashboard,
    label: "Dashboard",
    roles: FULL_ACCESS_ROLES,
    iconClassName: "dash_icon",
  },
  {
    to: "/allblogs",
    icon: LiaBlogger,
    label: "All Blogs",
    roles: CONTENT_ACCESS_ROLES,
    iconClassName: "blog_icon",
  },
  {
    to: "/createblog",
    icon: MdOutlineCreateNewFolder,
    label: "Create Blogs",
    roles: CONTENT_ACCESS_ROLES,
    iconClassName: "blog_icon",
  },
  {
    to: "/query",
    icon: MdOutlineContactMail,
    label: "Query",
    roles: FULL_ACCESS_ROLES,
    iconClassName: "page_icon",
  },
  {
    to: "/all-contact",
    icon: MdOutlineContactPhone,
    label: "Contact",
    roles: CONTACT_ACCESS_ROLES,
    iconClassName: "page_icon",
  },
  {
    to: "/jobpost",
    icon: MdWorkOutline,
    label: "Job",
    roles: JOB_ACCESS_ROLES,
    iconClassName: "page_icon",
  },
  // {
  //   to: "/newsLetter-user",
  //   icon: MdNewspaper,
  //   label: "NewsLetter users",
  //   roles: FULL_ACCESS_ROLES,
  //   iconClassName: "page_icon",
  // },
  // {
  //   to: "/Create-newsLetter",
  //   icon: MdOutlineCreateNewFolder,
  //   label: "NewsLetter Create",
  //   roles: FULL_ACCESS_ROLES,
  //   iconClassName: "page_icon",
  // },
  {
    to: "/all-case-study",
    icon: MdOutlineCases,
    label: "Case-Study",
    roles: CONTENT_ACCESS_ROLES,
    iconClassName: "page_icon",
  },
  {
    to: "/allpage-meta-data",
    icon: MdContactPage,
    label: "Page metadata",
    roles: CONTENT_ACCESS_ROLES,
    iconClassName: "page_icon",
  },
  
];

const Sidebar = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.authState);
  const logoutHandle = () => {
    dispatch(LogOutUser);
    console.log("hello");
  };

  const visibleSidebarItems = sidebarItems.filter((item) =>
    item.roles.includes(user?.role)
  );

  return (
    <div className="sidebar">
      <div className="sidebar_contrainer">
        <div className="sidebar_top">
          <img className="logo_image" src={Logo} alt="logo" />
        </div>
        <div className="sidebar_center">
          {visibleSidebarItems.map((item) => {
            const Icon = item.icon;

            return (
              <div className="sidebar_route_div" key={item.to}>
                <NavLink
                  to={item.to}
                  className={({ isActive }) => {
                    return isActive ? "active_nav" : "sidebar_content";
                  }}
                >
                  <Icon className={item.iconClassName} />
                  <p>{item.label}</p>
                </NavLink>
              </div>
            );
          })}
        </div>
        {/* /allpage-meta-data */}
        <div className="sidebar_route_div">
          <button className="sidebar_content" onClick={logoutHandle}>
            <RiLogoutBoxRLine className="page_icon" />
            <p>Log out</p>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
